module.exports = __webpack_public_path__ + "static/media/bg.539dfd7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bg.mp4
// module id = x/g7
// module chunks = 1